import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";

const AllOtherNotes = () => {
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [topics, setTopics] = useState([]);
  const [topicsId, setTopicsId] = useState("");
  // ---------------------------------------------------
  const [language, setLanguage] = useState("");
  const [othersNotes, setOthersNotes] = useState([]);
  const [video, setVideo] = useState(false);

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  //----------------------------------------------------------------------

  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  const getAllTopics = () => {
    axios
      .get(`${API_BASE_URL}/topics?categoryId=${categoryId}`)
      .then((response) => {
        // console.log(response);
        setTopics(response.data?.topics);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllTopics();
  }, [categoryId]);

  //----------------------------------------------------------------------

  const handleSubmit = (e) => {
    e.preventDefault();

    if (topicsId && language) {
      axios
        .get(`${API_BASE_URL}/notes?topicId=${topicsId}&language=${language}&video=${video}`)
        .then((result) => {
          console.log(result);
          const { data } = result.data;
          setOthersNotes(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // Navigation handlers
  const handleAddNewNote = () => {
    navigate("/upload-notes/add-other-notes");
  };

  const handleViewAllNotes = () => {
    navigate("/upload-notes/all-other-notes");
  };

  const handleGoBack = () => {
    navigate("/upload-notes/upload-all-notes");
  };

  const handleEdit = (id) => {
    navigate(`/upload-notes/edit-other-notes/${id}`);
  };

  const handleDelete = (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this note?"
    );

    if (confirmed) {
      axios
        .delete(`${API_BASE_URL}/admin/notes/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then(() => {
          // Filter out the deleted note from the state
          setOthersNotes((prevNotes) =>
            prevNotes.filter((note) => note._id !== id)
          );
          alert("Note deleted successfully");
        })
        .catch((error) => {
          console.error("Error deleting note:", error);
          alert("Failed to delete the note. Please try again.");
        });
    }
  };
  return (
    <div id="allschoolnotes-inner-wrapper">
      <BiArrowBack
        onClick={handleGoBack}
        className="left-arrow-icon mt-3"
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          fontSize: "25px",
          color: "#000", // Customize the color as needed
        }}
      />

      <div className="allschoolnotes-header-div">
        <h5>All Nios Notes</h5>
        <div className="allschoolnotes-header-btns">
          <button className="add-note-btn" onClick={handleAddNewNote}>
            + Upload Notes
          </button>
          <button className="all-notes-btn" onClick={handleViewAllNotes}>
            All Notes
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="note-detail-form form-container">
        <div className="input-group">
          <div style={{ paddingBottom: "10px" }}>
            <label className="label">Category</label>
          </div>
          <select
            className="select-dropdown"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            required
          >
            <option value="">-Select Category-</option>
            {category &&
              category.map((classes) => (
                <option value={classes._id} key={classes._id}>
                  {classes?.category}
                </option>
              ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Category Topic</label>
          <select
            className="new-chapter-dropdown"
            value={topicsId}
            onChange={(e) => setTopicsId(e.target.value)}
            required
          >
            <option value="">-Select Topic-</option>
            {topics &&
              topics.map((item, idx) => (
                <option key={idx} value={item._id}>
                  {item?.topic}
                </option>
              ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Select Language</label>
          <select
            className="new-chapter-dropdown"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            required
          >
            <option value="">-Select Language-</option>
            <option value="hindi">Hindi</option>
            <option value="english">English</option>
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Video Filter</label>
          <select
            className="new-chapter-dropdown"
            value={video}
            onChange={(e) => setVideo(e.target.value)}
            required
          >
            {/* <option value="">-Select Language-</option> */}
            <option value="false">All</option>
            <option value="true">Videos only</option>
          </select>
        </div>

        <div className="form1-btns">
          <button className="btn-save">Search Notes</button>
        </div>
      </form>

      <div className="allschoolnotes-table-container">
        <h5>All Nios Notes</h5>
        <table className="allschoolnotes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Notes Title</th>
              <th>Notes File</th>
              <th>Language</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {othersNotes.length ? (
              othersNotes.map((schoolNote, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{schoolNote.noteTitle}</td>
                  <td>
                    <Link
                      to={`${API_BASE_URL}/uploads/${schoolNote.noteFile}`}
                      target="_blank"
                    >
                      {schoolNote.noteFile}
                    </Link>
                  </td>
                  <td>{schoolNote.language}</td>
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(schoolNote._id)}
                    ></i>
                    &nbsp;&nbsp;
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(schoolNote._id)}
                    ></i>
                  </td>
                </tr>
              ))
            ) : (
              <div className="fs-4">No Data Found</div>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllOtherNotes;
